import { Auth } from 'aws-amplify';

export const getJwtTokenFromCurrentSession = async () => {
  const session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
};
